import { api } from '../axios'
import type { ApiResponse, Staff } from '@/types'
import type {
  GetStaffParams,
  GetStaffResponse,
  CreateStaffData,
  UpdateStaffData,
  UpdateStaffStatusData,
} from './staff.static'

export const staffService = {
  async getStaff(params?: GetStaffParams): Promise<GetStaffResponse> {
    const response = await api.get<ApiResponse<GetStaffResponse>>('/staff', { params })
    return response.data.data
  },

  async getStaffMember(id: string): Promise<Staff> {
    const response = await api.get<ApiResponse<Staff>>(`/staff/${id}`)
    return response.data.data
  },

  async createStaff(data: CreateStaffData): Promise<Staff> {
    const response = await api.post<ApiResponse<Staff>>('/staff', data)
    return response.data.data
  },

  async updateStaff(id: string, data: UpdateStaffData): Promise<Staff> {
    const response = await api.patch<ApiResponse<Staff>>(`/staff/${id}`, data)
    return response.data.data
  },

  async updateStaffStatus(id: string, data: UpdateStaffStatusData): Promise<Staff> {
    const response = await api.patch<ApiResponse<Staff>>(`/staff/${id}/status`, data)
    return response.data.data
  },

  async deleteStaff(id: string): Promise<void> {
    await api.delete(`/staff/${id}`)
  },
}
